export default __webpack_public_path__ + "static/media/feb02.1cc1a919.jpg";